import { render, staticRenderFns } from "./DetailDealsKpi.vue?vue&type=template&id=7818555c&scoped=true&"
import script from "./DetailDealsKpi.vue?vue&type=script&lang=js&"
export * from "./DetailDealsKpi.vue?vue&type=script&lang=js&"
import style0 from "./DetailDealsKpi.vue?vue&type=style&index=0&id=7818555c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7818555c",
  null
  
)

export default component.exports